import { GameplayRoute } from './routes/gameplay';

export default [
    {
        path: ':slug',
        element: <GameplayRoute />,
    },
];
